/* Dansk katalog for locale-sales-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'adv.sales.productsShowMore': 'Vis mere',
  'adv.sales.productsNote': 'Beløbet under Størst omsætning er faktureret salg pr. produkt i det valgte år. Vækst og fald viser den procentvise ændring i omsætning fra samme produkt året før. Produkter uden sammenlignelige tal fra sidste år vises ikke under vækst og fald.',
  'adv.sales.productsPage': 'Side {page} af {pages}',
  'adv.sales.productsPrevious': 'Forrige side for {label}',
  'adv.sales.productsNext': 'Næste side for {label}',
  'adv.sales.scn.adjust.priceUp': 'Prisstigning',
  'adv.sales.scn.adjust.volumeDown': 'Fald i salgsvolumen',
  'sale.doc.invoice': 'Ny faktura',
  'sale.doc.quote': 'Nyt tilbud',
  'sale.doc.orderConfirmation': 'Ny ordrebekræftelse',
  'sale.doc.creditNote': 'Ny kreditnota',
  'sale.doc.other': 'Andet salg',
  'sale.howToCreate': 'Hvordan vil du lave {document}?',
  'sale.docIndefinite.invoice': 'en faktura',
  'sale.docIndefinite.quote': 'et tilbud',
  'sale.docIndefinite.orderConfirmation': 'en ordrebekræftelse',
  'sale.docIndefinite.creditNote': 'en kreditnota',
  'sale.docIndefinite.other': 'et andet salg',
  'sale.credit.title': 'Kreditering',
  'sale.credit.help': 'En kreditnota tilbagefører et salg. Beløbene indtastes positivt som på en faktura — Plumme vender fortegnet i bogføringen, så salgsindtægt og udgående moms reduceres, og debitoren krediteres.',
  'sale.credit.reason': 'Årsag til kreditering',
  'sale.credit.reasonHint': 'Påkrævet. Grundlaget skal vise, hvad der faktisk skete, ikke kun beløbet.',
  'sale.credit.reasonPh': 'Returnering af vare, prisnedslag, fejlfakturering ...',
  'sale.credit.link': 'Tilknyt faktura',
  'sale.credit.linkHint': 'Valgfrit. Hvis du tilknytter, hentes fakturanummeret automatisk, og kreditnotaen modregnes i fakturaens udestående.',
  'sale.credit.linkNone': 'Ingen tilknytning – frit tilgodehavende',
  'sale.credit.linkSearchPh': 'Søg på fakturanummer, kunde eller beløb ...',
  'sale.credit.linkNoMatches': 'Ingen fakturaer matcher søgningen',
  'sale.credit.linkShowMore': 'Vis flere fakturaer',
  'sale.credit.invoiceOption': 'Faktura {number} · {customer}',
  'sale.credit.invoiceOptionMeta': '{date} · {amount}',
  'sale.credit.linkLocked': 'Valgt fra fakturaen',
  'sale.credit.noNumber': 'Uden nummer',
  'sale.credit.reference': 'Vedrører (oprindeligt salg)',
  'sale.credit.referenceHint': 'Påkrævet uden fakturatilknytning. Angiv fakturanummer, aftale, periode eller system, som salget lå i.',
  'sale.credit.referencePh': 'F.eks. faktura 1042 eller »aftale 2025-04«',
  'sale.credit.linkedTo': 'Krediterer faktura {document}',
  'sale.credit.offsetBadge': 'Modregnes automatisk',
  'sale.credit.freeHint': 'Uden tilknytning bliver beløbet stående som kundens tilgodehavende. Du kan modregne det i en faktura eller betale det tilbage fra fakturalisten.',
  'sale.credit.date': 'Kreditnotadato',
  'sale.credit.numberLabel': 'Kreditnotanr.:',
  'sale.credit.amount': 'Beløb til gode',
  'sale.credit.previewNote': 'Beløbet er krediteret. Det modregnes i udestående eller betales tilbage.',
  'sale.credit.previewReason': 'Årsag:',
  'sale.credit.previewReference': 'Vedrører:',
  'sale.credit.set': 'Angiv detaljer',
  'sale.credit.edit': 'Ændr',
  'sale.credit.missing': 'Årsag og reference til oprindeligt salg skal være angivet, før kreditnotaen kan oprettes.',
  'sale.credit.noReference': 'Ingen reference angivet',
  'sale.credit.freeBadge': 'Frit tilgodehavende',
  'sale.credit.needReason': 'Skriv årsagen til krediteringen først',
  'sale.credit.needReference': 'Tilknyt en faktura, eller angiv hvilket oprindeligt salg kreditnotaen vedrører',
  'sale.credit.needDetails': 'Angiv årsag, og tilknyt en faktura eller angiv det oprindelige salg først',
  'sale.credit.create': 'Opret kreditnota',
  'sale.det.period': 'Periode',
  'sale.det.subscriptionFrom': 'Abonnement fra',
  'sale.det.subscriptionTo': 'Abonnement til',
  'sale.det.rentFrom': 'Leje fra',
  'sale.det.rentTo': 'Leje til',
  'sale.lines.descShortPh': 'F.eks. konsulenttime eller abonnement',
  'sale.from': 'Fra',
  'sale.to': 'Til',
  'sale.use': 'Brug',
  'sale.swap': 'Byt',
  'sale.show': 'Vis',
  'sale.edit': 'Redigér',
  'sale.download': 'Download',
  'sale.send': 'Send',
  'sale.add': 'Tilføj',
  'sale.save': 'Gem',
  'sale.saveChanges': 'Gem ændringer',
  'sale.thisSale': 'dette salg',
  'sale.step.kunde': 'Kunde',
  'sale.step.bilag': 'Bilag',
  'sale.step.detaljer': 'Detaljer',
  'sale.step.linjer': 'Linjer',
  'sale.step.forhandsvisning': 'Forhåndsvisning',
  'sale.title': 'Salg / Faktura / Tilbud',
  'sale.titleHelp': 'Registrér salg, lav faktura, tilbud eller ordrebekræftelse',
  'sale.docTypeHelpTitle': 'Dokumenttype',
  'sale.docTypeHelp': 'Vælg, hvilken slags salgsdokument du laver. Faktura er et betalingskrav til kunden. Tilbud er et uforpligtende pristilbud. Ordrebekræftelse bekræfter en aftalt bestilling. Andet salg bruges til salg uden for systemet, hvor du uploader et bilag som dokumentation.',
  'sale.stepsHelpTitle': 'Trinene i salget',
  'sale.stepsHelp': 'Salget er delt i fire trin: Kunde, Detaljer, Linjer og Forhåndsvisning (for Andet salg: Bilag, Detaljer, Linjer og Forhåndsvisning). Tryk på et trin for at springe dertil. Et trin markeres, hvis noget mangler, før dokumentet kan oprettes.',
  'sale.viewHelpTitle': 'Skift visning',
  'sale.viewHelpToOnePage': 'Skifter fra det trinvise forløb til én samlet side, hvor alle felter vises på én gang ved siden af en levende forhåndsvisning. Hurtigere, når du er vant til formularen.',
  'sale.viewHelpToSteps': 'Skifter fra én samlet side til et roligt trinvist forløb, hvor du udfylder én ting ad gangen — kunde, detaljer, linjer og forhåndsvisning. Godt, når du gerne vil have vejledning undervejs.',
  'sale.toOnePage': 'Skift til alt på én side',
  'sale.toSteps': 'Skift til trin for trin',
  'sale.stepByStep': 'Trin for trin',
  'sale.previewHelpTitle': 'Forhåndsvisning',
  'sale.previewHelp': 'Her ser du, hvordan det færdige dokument ser ud for kunden — med afsender, kundeinfo, linjer og total. Det opdateres, mens du udfylder, så du kan kontrollere alt, før du opretter eller sender.',
  'sale.previewToggleHelp': 'Viser eller skjuler den levende forhåndsvisning ved siden af formularen. Skjul den, hvis du vil have mere plads til felterne.',
  'sale.previewHide': 'Skjul forhåndsvisning',
  'sale.previewShow': 'Vis forhåndsvisning',
  'sale.previewHeading': 'Sådan ser dokumentet ud',
  'sale.backToVouchers': 'Tilbage til transaktioner',
  'sale.resetTitle': 'Nulstil formularen, og start forfra',
  'sale.reset': 'Nulstil',
  'sale.resetDone': 'Formularen er nulstillet',
  'sale.back': 'Tilbage',
  'sale.next': 'Næste',
  'sale.draftSaved': 'Kladde gemt',
  'sale.draftSavedHelp': 'Kladden ligger i fakturalisten, som den ser ud nu. Hvis du ændrer noget, kan du gemme igen — det opdaterer den samme kladde.',
  'sale.saveDraft': 'Gem kladde',
  'sale.saveDraftHelpTitle': 'Gem kladde',
  'sale.saveDraftHelp': 'Gemmer salget som en kladde i fakturalisten uden at sende eller oprette det. Du kan fortsætte, hvor du slap, senere.',
  'sale.saveDraftHelpLong': 'Gemmer salget som en kladde i fakturalisten uden at sende eller oprette det. Du kan trygt forlade siden og fortsætte, hvor du slap, senere.',
  'sale.saveDraftHelpShort': 'Gemmer salget som en kladde i fakturalisten uden at sende eller oprette det. Du kan trygt forlade siden og fortsætte senere.',
  'sale.drafts': 'Kladder',
  'sale.draftsTitle': 'Påbegyndte salg, du endnu ikke har oprettet',
  'sale.noDrafts': 'Ingen kladder',
  'sale.searchDrafts': 'Søg i kladder...',
  'sale.deleteDraft': 'Slet kladde',
  'sale.deleteDraftTitle': 'Slet kladde?',
  'sale.deleteDraftBody': 'Er du sikker på, at du vil slette kladden for {customer}? Det kan ikke fortrydes.',
  'sale.det.help': 'Datoer, referencer og kommentar til dokumentet. Fakturadato/forfaldsdato styrer, hvornår kravet gælder og forfalder. »Vores reference« er sagsbehandleren hos jer, »Jeres reference« er kundens projekt eller kontaktperson. For faktura kan du også slå gentagelse til, så den sendes automatisk hver periode.',
  'sale.det.date': 'Dato',
  'sale.det.due': 'Forfald',
  'sale.det.ourRef': 'Vores reference',
  'sale.det.ourRefPh': 'F.eks. sagsbehandler hos os',
  'sale.det.theirRef': 'Jeres reference',
  'sale.det.theirRefPh': 'Jeres reference / projekt',
  'sale.det.payTo': 'Betal til',
  'sale.det.payToHelp': 'Den bankkonto, kunden skal betale fakturaen til. Listen viser de bankkonti, du har gemt — fakturakontoen fra indstillingerne er valgt på forhånd, og du kan tilføje en ny konto direkte herfra.',
  'sale.det.payToDefault': 'Fakturakonto',
  'sale.det.payToEmpty': 'Ingen bankkonto gemt',
  'sale.det.payToAdd': '+ Tilføj bankkonto ...',
  'sale.det.comment': 'Kommentar',
  'sale.det.commentPh': 'Valgfri kommentar, der vises på dokumentet',
  'sale.det.savedComments': 'Gemte kommentarer',
  'sale.det.saveComment': 'Gem kommentar',
  'sale.det.useComment': 'Brug kommentar',
  'sale.det.noSavedComments': 'Ingen gemte kommentarer endnu.',
  'sale.det.deliveryFrom': 'Leverings-/udførelsesperiode - Fra',
  'sale.det.deliveryTo': 'Leverings-/udførelsesperiode - Til',
  'sale.det.repeating': 'Gentagende',
  'sale.det.repeatingHelpTitle': 'Gentagende faktura',
  'sale.det.repeatingHelp': 'Slå til, hvis fakturaen skal sendes automatisk med jævne mellemrum — for eksempel hver måned ved abonnement. Du vælger interval og forfald, så opretter og sender Plumme en ny faktura hver periode, uden at du behøver at gøre noget.',
  'sale.det.sentEvery': 'Sendes hver',
  'sale.period.week': 'Uge',
  'sale.period.month': 'Måned',
  'sale.period.quarter': 'Kvartal',
  'sale.period.year': 'Årligt',
  'sale.det.sameDay': 'Samme dag',
  'sale.lines.help': 'Varerne og ydelserne på salget. Hver linje har antal, pris, momssats og eventuel rabat, og linjesummen beregnes automatisk. Vælg et gemt produkt, eller skriv fritekst, og træk i håndtaget til venstre for at ændre rækkefølgen.',
  'sale.lines.add': 'Tilføj linje',
  'sale.lines.product': 'Produkt',
  'sale.lines.productPh': 'Søg eller skriv nyt produkt...',
  'sale.lines.noProductMatch': 'Ingen gemte produkter matcher',
  'sale.lines.editProduct': 'Redigér produkt',
  'sale.lines.productName': 'Produktnavn',
  'sale.lines.description': 'Beskrivelse',
  'sale.lines.descriptionPh': 'Valgfri beskrivelse af produktet/linjen',
  'sale.lines.qty': 'Antal',
  'sale.lines.vat': 'Moms',
  'sale.lines.discount': 'Rabat',
  'sale.lines.netSum': 'Linjesum ekskl. moms',
  'sale.lines.toggleVat': 'Skift mellem ekskl. og inkl. moms',
  'sale.lines.more': 'Mere',
  'sale.lines.less': 'Mindre',
  'sale.lines.searchAccount': 'Søg konto...',
  'sale.lines.noAccountMatch': 'Ingen konti matcher søgningen.',
  'sale.lines.pickAccount': 'Vælg konto',
  'sale.lines.searchProductPh': 'Søg på navn eller beskrivelse...',
  'sale.sum.help': 'Totalen for hele salget: summen ekskl. moms plus moms er lig med det beløb, kunden skal betale. Tallene opdateres automatisk, når du ændrer linjerne.',
  'sale.att.title': 'Vedhæftede filer',
  'sale.att.upload': 'Upload vedhæftet fil',
  'sale.att.drop': 'Træk filer hertil',
  'sale.att.dropHint': 'Billeder eller PDF, eller indsæt',
  'sale.att.pickFile': 'Vælg fil',
  'sale.att.dropToAdd': 'Slip den vedhæftede fil for at tilføje den',
  'sale.att.dragTip': 'Tip: du kan også trække filer direkte ind på siden.',
  'sale.att.forgot': 'Har du glemt nogle bilag? Slip bilaget her',
  'sale.att.fromInbox': 'Hent fra indbakke',
  'sale.att.uploadInstead': 'Upload bilag i stedet',
  'sale.att.view': 'Se bilaget',
  'sale.att.openPreview': 'Åbn i forhåndsvisning',
  'sale.send.title': 'Sender dokument',
  'sale.send.to': 'Send til',
  'sale.send.replyTo': 'Svar til',
  'sale.send.asPdf': 'Send som PDF-vedhæftning',
  'sale.send.asLink': 'Send som link',
  'sale.send.pdfHint': 'Kunden får dokumentet direkte i e-mailen.',
  'sale.send.linkHint': 'Giver læsestatus, når kunden åbner dokumentet.',
  'sale.send.how': 'Hvordan skal dokumentet sendes?',
  'sale.send.newRecipient': 'Ny e-mailadresse …',
  'sale.send.saveContact': 'Gem som kontaktperson hos {customer}',
  'sale.send.thisCustomer': 'kunden',
  'sale.send.contactName': 'Navn',
  'sale.send.contactNamePh': 'Anne Jensen',
  'sale.send.contactRole': 'Rolle',
  'sale.send.contactRolePh': 'Regnskab',
  'sale.send.contactSaveFailed': 'Dokumentet blev sendt, men kontaktpersonen kunne ikke gemmes.',
  'sale.send.emailPh': 'navn@eksempel.dk',
  'sale.send.viewDocument': 'Se dokumentet',
  'sale.preview.sender': 'Afsender:',
  'sale.preview.invoiceNo': 'Fakturanr.:',
  'sale.preview.invoiceDate': 'Fakturadato:',
  'sale.preview.dueDate': 'Forfaldsdato:',
  'sale.preview.ourRef': 'Vores reference:',
  'sale.preview.theirRef': 'Jeres reference:',
  'sale.preview.comment': 'Kommentar:',
  'sale.preview.accountNo': 'Kontonr.:',
  'sale.preview.toPay': 'At betale:',
  'sale.preview.net': 'Netto',
  'sale.preview.vat': 'Moms',
  'sale.preview.paid': 'Betalt',
  'sale.preview.toPayShort': 'At betale',
  'sale.preview.receipt': 'Kvittering',
  'sale.preview.paymentHint': 'Angiv venligst fakturanummer ved betaling',
  'sale.preview.currencyNote': 'Alle beløb er angivet i {currency}',
  'sale.lines.fromDraftDescr': 'Overført fra kladde',
  'sale.att.maxSize': 'En vedhæftet fil må højst være {max}.',
  'sale.att.addedOne': '1 vedhæftet fil tilføjet',
  'sale.att.addedMany': '{count} vedhæftede filer tilføjet',
  'sale.comment.deleted': 'Kommentar slettet',
  'sale.comment.deleteFailed': 'Kunne ikke slette kommentaren.',
  'sale.comment.writeFirst': 'Skriv en kommentar først',
  'sale.comment.updated': 'Kommentar opdateret',
  'sale.comment.saveFailed': 'Kunne ikke gemme kommentaren.',
  'sale.comment.alreadySaved': 'Kommentaren er allerede gemt',
  'sale.comment.saved': 'Kommentar gemt',
  'sale.comment.backendUnavailable': 'Kommentarer er ikke koblet til backend.',
  'sale.det.offerDate': 'Tilbudsdato',
  'sale.det.orderDate': 'Ordredato',
  'sale.det.saleDate': 'Salgsdato',
  'sale.det.invoiceDateLabel': 'Fakturadato',
  'sale.det.validUntil': 'Gyldig til',
  'sale.det.dueDateLabel': 'Forfaldsdato',
  'sale.textLine.titleUpdate': 'Opdater tekstlinje',
  'sale.textLine.titleNewHeading': 'Ny overskrift',
  'sale.textLine.titleNewText': 'Ny tekstlinje',
  'sale.textLine.update': 'Opdater',
  'sale.textLine.typeLabel': 'Type',
  'sale.textLine.typeText': 'Tekstlinje',
  'sale.textLine.typeHeading': 'Overskrift',
  'sale.textLine.nameLabel': 'Navn',
  'sale.textLine.namePhHeading': 'F.eks. Arbejde',
  'sale.textLine.namePhText': 'F.eks. Produkt X',
  'sale.textLine.textLabel': 'Tekst',
  'sale.textLine.textPh': 'Valgfri tekst, der vises under linjen',
  'sale.textLine.styleFor': 'Stil for {target}',
  'sale.textLine.boldShort': 'F',
  'sale.textLine.italicShort': 'K',
  'sale.textLine.useDivider': 'Brug skillelinje',
  'sale.textLine.dividerHint': 'Vis en linje under teksten i dokumentet.',
  'sale.textLine.searchPhHeading': 'Søg eller skriv overskrift...',
  'sale.textLine.searchPhText': 'Søg eller skriv tekstlinje...',
  'sale.textLine.noMatch': 'Ingen gemte tekstlinjer matcher',
  'sale.textLine.addAsHeading': 'Tilføj "{value}" som ny overskrift',
  'sale.textLine.addAsText': 'Tilføj "{value}" som ny tekstlinje',
  'sale.textLine.headingSaved': 'Overskrift gemt',
  'sale.textLine.textSaved': 'Tekstlinje gemt',
  'sale.textLine.headingAdded': 'Overskrift tilføjet',
  'sale.textLine.textAdded': 'Tekstlinje tilføjet',
  'sale.textLine.saveFailed': 'Kunne ikke gemme tekstlinjen.',
  'sale.det.durationMonth1': '1 måned',
  'sale.det.durationMonth3': '3 måneder',
  'sale.det.durationMonth6': '6 måneder',
  'sale.det.durationMonth12': '12 måneder',
  'sale.lines.typeProduct': 'Produktlinje',
  'sale.lines.typeSpacer': 'Mellemrum',
  'sale.lines.noText': 'Uden tekst',
  'sale.lines.qtyUnit': '{qty} stk.',
  'sale.preview.receiptNoLabel': 'Kvitteringsnr.:',
  'sale.preview.quoteNoLabel': 'Tilbudsnr.:',
  'sale.preview.orderNoLabel': 'Ordrenr.:',
  'sale.preview.backToOther': 'Tilbage til Andet salg',
  'sale.preview.backToInvoice': 'Tilbage til faktura',
  'sale.preview.vatMoms': 'Moms',
  'sale.preview.continuesNextPage': 'Fortsætter på næste side',
  'sale.att.labelWithName': 'Vedhæftet fil · {name}',
  'sale.att.dropHere': 'Slip bilaget her',
  'sale.att.otherSaleHint': 'Andet salg er generelle salg uden for systemet - upload et billede eller en PDF som dokumentation.',
  'sale.att.previewHint': 'Tryk på en af dine vedhæftede filer eller Se kvittering for at få vist en forhåndsvisning.',
  'sale.att.viewReceipt': 'Se kvittering',
  'sale.att.createReceipt': 'Lav kvittering',
  'sale.mode.subtitle': 'Vælg et roligt trin-for-trin-flow, eller behold alle felterne samlet på én side.',
  'sale.mode.stepsDesc': 'Kunde, detaljer, linjer og forhåndsvisning - én ting ad gangen. God for begyndere.',
  'sale.mode.onePageDesc': 'Hele fakturaen samlet med levende forhåndsvisning. Hurtigt for de erfarne.',
  'sale.draft.noCustomer': 'Uden kunde',
  'sale.draft.noMatchesTitle': 'Ingen resultater',
  'sale.draft.noMatchesText': 'Ingen kladder matcher søgningen.',
  'sale.draft.emptyText': 'Påbegyndte salg gemmes her, når du trykker på Gem kladde.',
  'sale.draft.colSale': 'Salg',
  'sale.draft.noNumber': 'Uden nummer',
  'sale.draft.colDate': 'Dato',
  'sale.draft.colAmount': 'Beløb',
  'sale.draft.deleteFailed': 'Kunne ikke slette kladden.',
  'sale.draft.saveFailed': 'Kunne ikke gemme kladden.',
  'sale.draft.deleteUnavailable': 'Sletning af kladder er ikke koblet til backend.',
  'sale.draft.onlyDraftsDelete': 'Kun kladder kan slettes her',
  'sale.draft.deleted': 'Kladde slettet',
  'sale.draft.saveUnavailable': 'Lagring af kladder er ikke koblet til backend.',
  'sale.draft.savedToList': 'Kladden er gemt i fakturalisten',
  'sale.create.invoice': 'Opret faktura',
  'sale.create.quote': 'Opret tilbud',
  'sale.create.order': 'Opret ordrebekræftelse',
  'sale.create.other': 'Registrér salg',
  'sale.create.needMatchingPartials': 'Summen af delbetalingerne skal først stemme med salgets total',
  'sale.create.needLineOrAttachment': 'Tilføj en linje eller et bilag først',
  'sale.create.needCustomerAndProduct': 'Vælg en kunde, og tilføj mindst ét produkt først',
  'sale.create.needCustomer': 'Vælg en kunde først',
  'sale.create.needProduct': 'Tilføj mindst ét produkt først',
  'sale.create.receiptSendingBackground': 'Kvitteringen sendes i baggrunden',
  'sale.create.receiptSentEmail': 'Kvitteringen blev sendt via e-mail.',
  'sale.create.recurringSaveFailed': 'Fakturaen blev oprettet, men den gentagende aftale kunne ikke gemmes.',
  'sale.create.createFailed': 'Kunne ikke oprette salget.',
  'sale.create.createdTitle': '{doc} {num} er oprettet.',
  'sale.create.saleCreatedBody': 'Salget er bogført. Du kan gemme kvitteringen, sende dokumentation til kunden eller lukke.',
  'sale.create.docCreatedBody': 'Du kan gemme {def} som PDF eller sende {pron} videre på e-mail.',
  'sale.create.pdfReceiptLabel': 'PDF/Kvittering',
  'sale.create.pdfLabel': 'PDF',
  'sale.send.unavailableSale': 'Afsendelse er ikke tilgængelig for dette salg.',
  'sale.send.unavailableDocument': 'Afsendelse er ikke tilgængelig for dette dokument.',
  'sale.send.failed': 'Afsendelsen mislykkedes.',
  'sale.send.customerFallback': 'Kunde',
  'sale.send.defaultContactRole': 'Standardkontakt',
  'sale.send.contactFallback': 'Kontaktperson',
  'sale.send.recipientFallback': 'Modtager',
  'sale.send.receiptTitle': 'Send kvittering',
  'sale.send.howToSend': 'Hvordan vil du sende {doc}?',
  'sale.send.receiptEmailHint': 'Indtast den e-mailadresse, kvitteringen skal sendes til.',
  'sale.send.chooseDeliveryHint': 'Vælg, om kunden skal have en PDF i e-mailen eller et link, som Postplumma kan følge med i.',
  'sale.send.allCustomersInList': 'Alle kunder på listen ({count})',
  'sale.send.needEmailFirst': 'Indtast e-mail på kunden eller en kontaktperson før afsendelse.',
  'sale.send.stepDraftPrep': 'Kladde klargøres',
  'sale.send.stepArriving': 'Postplumma ankommer',
  'sale.send.stepSuccess': 'Succes! Postplumma er på vej.',
  'sale.send.receiptReadyNoEmail': 'Kvitteringen er klar, men der blev ikke sendt nogen e-mail.',
  'sale.send.sendingInBackground': '{doc} sendes i baggrunden',
  'sale.send.sentAsLinkShort': '{doc} blev sendt som link.',
  'sale.send.sentAsLinkTracked': '{doc} blev sendt som link. Du kan følge læsestatus i fakturalisten.',
  'sale.send.sentAsEmail': '{doc} blev sendt på e-mail.',
  'sale.send.readyNoEmail': '{doc} er klar, men der blev ikke sendt nogen e-mail.',
  'sale.send.sentToRecipients': 'Sendt til {count} modtagere.',
  'sale.send.notProvided': 'Ikke angivet',
  'sale.send.spamTip': 'Tip: Hvis kunden ikke kan finde e-mailen, så bed dem tjekke uønsket post/spam.',
  'sale.inboxPicker.tabInbox': 'Indbakke ({count})',
  'sale.inboxPicker.tabDocumentation': 'Dokumentation ({count})',
  'sale.inboxPicker.searchDocumentation': 'Søg i dokumentation',
  'sale.inboxPicker.searchInbox': 'Søg i indbakken',
  'sale.inboxPicker.selectTip': 'Tip: Hold Shift nede for at vælge flere i træk, eller Ctrl/Cmd for at vælge enkeltvis.',
  'sale.inboxPicker.emptyDocumentation': 'Ingen dokumenter matcher søgningen.',
  'sale.inboxPicker.emptyInbox': 'Ingen bilag i indbakken matcher søgningen.',
  'sale.inboxPicker.fallbackReceipt': 'Bilag',
  'sale.inboxPicker.fallbackDocument': 'Dokument',
  'sale.inboxPicker.fallbackDocumentation': 'Dokumentation',
  'sale.lines.subscriptionPeriod': 'Abonnement - {{period}}',
  'sale.lines.months12': '12 mdr.',
  'sale.lines.month1': '1 md.',
  'sale.lines.rentalPrice': 'Udlejning - {{price}}',
  'sale.lines.addAsNewProduct': 'Tilføj "{{value}}" som nyt produkt',
  'sale.lines.useDivider': 'Brug skillelinje',
  'sale.lines.dividerHint': 'Vis en linje under denne række i dokumentet.',
  'sale.preview.colDescription': 'Beskrivelse',
  'sale.preview.colQty': 'Antal',
  'sale.preview.colPrice': 'Pris',
  'sale.preview.colDiscount': 'Rabat',
  'sale.preview.colSum': 'I alt',
  'sale.doc.invoiceName': 'Faktura',
  'sale.doc.quoteName': 'Tilbud',
  'sale.doc.orderConfirmationName': 'Ordrebekræftelse',
  'sale.doc.creditNoteName': 'Kreditnota',
  'sale.draft.colType': 'Type',
  'sale.period.every14days': 'Hver 14. dag',
  'sale.det.dueDays': '{{count}} dage',
  'sale.lines.priceExVat': 'Pris ekskl. moms',
  'sale.lines.priceIncVat': 'Pris inkl. moms',
  'sale.lines.lineNumber': 'Linje {{n}}',
  'sale.lines.pickProduct': 'Vælg produkt',
  'sale.lines.freeText': 'Fritekst',
  'sale.lines.spacerHint': 'En tom linje vises som mellemrum i dokumentet.',
  'sale.lines.chooseLineType': 'Vælg linjetype',
  'agreements.notSent': 'Ikke sendt',
  'agreements.error.missingCustomerEmail': 'Kunden mangler e-mailadresse. Indtast e-mail på kunden, så sendes fakturaen ved næste kørsel.',
  'agreements.error.missingCustomer': 'Kunden findes ikke længere eller er arkiveret. Vælg en aktiv kunde til aftalen.',
  'agreements.warning.missingCustomerEmail': 'Kunden mangler e-mailadresse',
  'agreements.warning.missingCustomerEmailHelp': 'Automatisk afsendelse kræver en e-mailadresse. Indtast den på kunden før næste fakturadato, ellers bliver fakturaen ikke sendt.',
});
